<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner rew19-contents-inner--wide">
      <h2 class="rew19-contents-title">나의 NTC</h2>

      <div class="rew19_tabwrap">
        <ul class="rew19_linetab_pop nav nav-tabs nav-stacked">
          <li class="active">
            <router-link :to="{name:'ntcCurrentList'}">나의 NTC 진행현황</router-link>
          </li>
          <li>
            <router-link :to="{name:'ntcHistoryList'}">나의 NTC History</router-link>
          </li>
        </ul>
      </div>

      <div class="rew19_payment_list-total">
        총
        <strong>{{viewData.ntcNo != '' ? 1 : 0}}</strong>개
      </div>

      <div class="rew19_payment_wrap">
        <table class="rew19-table-col">
          <caption>콜 테이블</caption>
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="table-col__head">NTC 번호</th>
              <th class="table-col__head">결제일</th>
              <th class="table-col__head">회차</th>
              <th class="table-col__head">결제금액</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="viewData.ntcNo != ''" class="clickRow"
                @click="onClickItem(viewData)">
              <td class="table-col__data">{{viewData.ntcNo}}</td>
              <td class="table-col__data">매월 {{viewData.payment_date}}일</td>
              <td class="table-col__data">{{viewData.paymentCount}}</td>
              <td class="table-col__data">{{$fmt.WON(viewData.totalPrice)}}원
                <span class="rew19_nextLine" v-if="viewData.payProcess_status == '2'" >
                  <a @click.stop.prevent="openPaymentInfoDialog" class="rew19_btn_intable active">재결제</a>
                </span>
              </td>
            </tr>
            <tr v-if="viewData.ntcNo == ''">
              <td colspan="4" class="table-col__data no_data">{{viewData.message}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
    </div>
    <!--rew19_contents_inner-->

    <payment-info-dialog
      :show="paymentInfoDialogShow"      
      :mode="paymentInfoDialog.mode"
      :showCardTerm="true"
      :showInstMonth="false"
      :showReceiptNo="false"
      @close="changePaymentInfo"
      ref="paymentInfoDialog"
    ></payment-info-dialog>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PaymentInfoDialog from '@/components/popup/PaymentInfoDialog';

import DF from 'dateformat';

export default {
  name: "ntcCurrentList",
  extends: AroBase,
  components: {PaymentInfoDialog},
  computed: {
     isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
     }
  },
  data() { 
    return {     
      //View Data     
      viewData : {},
      params : {      
        
      },

      //결제정보
      paymentInfoDialogShow : false,
      paymentInfoDialog : {},

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadData();
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },

    /**
     * API Request
     */
    //나의 ntc 정보 가져오기
    apiGetNtc(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_ntc`, {});
    },

    // ntc 재결제
    apiNtcRepayment(paymentInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc_repayment`, {
        params : {
          ...paymentInfo
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadData(){
      let _this = this;

      //show loading
      _this.$showLoading();      
      _this.apiGetNtc().then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData = {...res.data};
          
        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //상세 이동
    onClickItem(item){
      let _this = this;
      _this.$router.push(`${_this.$aroBasePath}/ntcCurrentDetail`);
    },

    //Open Dialog결제정보 변경
    openPaymentInfoDialog(){
      let _this = this;

      //pass data to dialog
      _this.paymentInfoDialog = {
        //..._this.paymentInfoDialog,
        mode : 2, //신용카드, 계좌이체 모두
        paymentType : 2,
        card :{
          birth : '',
          cardnumber : '',
          
          useTerm : _this.$aroApiBasePath + _this.AroConst.VALUE_NTC_CARD_USE_TERM
        },
        account:{

        }   
      };
      _this.$refs.paymentInfoDialog.initData(_this.paymentInfoDialog);
      _this.paymentInfoDialogShow = true; 
    },

    //결제정보 변경
    changePaymentInfo(isOk, data){
      let _this = this;

      _this.paymentInfoDialogShow = false;  
                
      if(!isOk){
        //Do nothing
        return;
      }

      let paymentInfo = {
        member_name : _this.getMemberNmKr(),
        birth_dt : data.card.birth,
        ccard_no : data.card.cardnumber,
        ccard_exp : data.card.expYY + data.card.expMM,
        passwd : data.card.pwd,
      };
      
      //show loading
      _this.$showLoading();      
      _this.apiNtcRepayment(paymentInfo).then((res)=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("결제 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadList();
          return;          
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

  }
}
</script>
<style>

tr.clickRow{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ntc/currentList.vue